<div class="container-fluid tender-header-bg shadow-sm">
  <!-- Row 1: Title/Status and Stats Toggle -->
  <div class="d-flex flex-row align-items-center justify-content-between border-bottom py-3 tender-title-row">
    <div class="d-flex flex-row align-items-center tender-title-wrap">
      <h1 class="h4 mb-0 text-muted me-2 tender-title-label">Tender</h1>
      <h1 class="h4 mb-0 d-inline-block text-truncate me-2 tender-title-name" style="max-width: 400px; color: var(--heading-color);"
        placement="bottom" container="body" ngbTooltip="{{tender.name}}">{{tender.name}}</h1>

      <jft-tender-status [status]="tender.status" class="flex-shrink-0"></jft-tender-status>
    </div>

    <div class="tender-stats-toggle">
      <a class="nav-link pe-lg-0 text-muted text-nowrap" href="javascript:void(0);" (click)="collapseStats()"
        [attr.aria-expanded]="!isCollapsed" aria-controls="collapseTenderStats">
        <span class="d-none d-sm-inline">Tender </span>Stats
        <i class="fas" [class.fa-angle-right]="isCollapsed" [class.fa-angle-down]="!isCollapsed"></i>
      </a>
    </div>
  </div>

  <!-- Row 2: Navigation and Actions -->
  <div class="d-flex flex-row flex-wrap align-items-center justify-content-between border-bottom tender-nav-row">
    <ul class="nav nav-links tender-section-nav">
      <li class="nav-item">
        <!--
          Locked, not merely hidden: the route carries SealedTenderGuard too. A tab
          that renders and then bounces is the bug this pattern exists to kill, and a
          route with no tab is a bookmark away from opening anyway.
          canAccessTenderOverview() was written for this and had never been called.
        -->
        <a *ngIf="canAccessTenderOverview()" class="nav-link ps-0" [routerLink]="['overview']"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Tender Overview</a>
        <span *ngIf="!canAccessTenderOverview()" class="nav-link ps-0 text-muted"
          [ngbTooltip]="getTenderOverviewRestrictionTooltip()" placement="bottom"
          style="cursor: not-allowed;">Tender Overview</span>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/tenders',tender.id,'locations']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}">
          Locations
        </a>
      </li>
      <li class="nav-item">
        <a *ngIf="canAccessAwards()" class="nav-link" [routerLink]="['/tenders',tender.id,'awards']"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
          Awards
        </a>
        <span *ngIf="!canAccessAwards()" class="nav-link text-muted" [ngbTooltip]="getAwardsRestrictionTooltip()"
          placement="bottom" style="cursor: not-allowed;">
          Awards
        </span>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/tenders',tender.id,'suppliers']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          Suppliers
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/tenders',tender.id,'invitation']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          Invitation
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/tenders',tender.id,'reports']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}">
          Reports
        </a>
      </li>
      <li class="nav-item" *ngIf="user.canManageAdvanced(tender) && !user.isAnyRestricted()">
        <div class="nav-divider"></div>
      </li>
      <li class="nav-item" *ngIf="user.canManageAdvanced(tender) && !user.isAnyRestricted()">
        <a class="nav-link" [routerLink]="['/tenders', tender.id, 'analytics-settings']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}">
          Analytics Settings
        </a>
      </li>
    </ul>

    <!-- Mobile: toggle the tender actions list -->
    <button type="button" class="tender-actions-toggle d-lg-none" (click)="actionsOpen = !actionsOpen"
      [attr.aria-expanded]="actionsOpen" aria-label="Tender actions">
      <i class="fas fa-ellipsis-v"></i>
    </button>

    <ul class="nav nav-links tender-actions-nav" [class.open]="actionsOpen">
      <li *ngIf="!company.isChild" class="nav-item d-inline-block">
        <a (click)="openImportBidXlsModalContacts()" href="javascript:void(0)" class="nav-link">
          <i class="fas fa-file-excel me-2"></i> Excel Bid Importer
        </a>
      </li>
      <li ngbDropdown class="nav-item d-inline-block">
        <a ngbDropdownToggle class="nav-link dropdown-toggle pointer">
          <i class="fas fa-file-excel me-2"></i> Export Bids
          <span *ngIf="loadingExport" class="spinner-border text-primary spinner-border-sm"
            style="vertical-align: middle;" role="status" aria-hidden="true">
          </span>
        </a>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
          <!-- Show export options only if not sealed tender or if sealed tender allows access -->
          <ng-container>
            <a *ngIf="canExportBidData()" (click)="exportTenderOverviewAll($event)" href="javascript:void(0)"
              class="dropdown-item d-flex flex-row">
              <ng-icon name="lucideFileSpreadsheet" class="me-2"></ng-icon>
              <div class="flex-grow-1">
                Export All-in-One Bid Sheet to Excel
                <span *ngIf="preferredCurrencyCode" class="text-muted small">
                  <br> Airline Currency {{preferredCurrencyCode}} and Supplier Currency</span>
              </div>
            </a>
            <span *ngIf="!canExportBidData()" class="dropdown-item d-flex flex-row text-muted"
              style="cursor: not-allowed; opacity: 0.6;">
              <ng-icon name="lucideFileSpreadsheet" class="me-2"></ng-icon>
              <div class="flex-grow-1">
                Export All-in-One Bid Sheet to Excel
                <span class="text-muted small"><br>Restricted during active rounds</span>
              </div>
            </span>
            <div class="dropdown-divider"></div>
            <a *ngIf="canExportBidData()" href="javascript:void(0)" (click)="openExportTemplatePicker($event)"
              class="dropdown-item d-flex flex-row">
              <i class="fas fa-sliders-h me-2 mt-1"></i>
              <div class="flex-grow-1">
                Advanced Data Export
                <span class="text-muted small"><br>Use custom export templates</span>
              </div>
            </a>
            <span *ngIf="!canExportBidData()" class="dropdown-item d-flex flex-row text-muted"
              style="cursor: not-allowed; opacity: 0.6;">
              <i class="fas fa-sliders-h me-2 mt-1"></i>
              <div class="flex-grow-1">
                Advanced Data Export
                <span class="text-muted small"><br>Restricted during active rounds</span>
              </div>
            </span>
          </ng-container>

          <!-- Show message for sealed tenders when exports are not available -->
          <ng-container *ngIf="!canExportBidData()">
            <div class="dropdown-divider"></div>
            <div class="dropdown-item-text text-muted">
              <small><i class="fas fa-info-circle me-1"></i>Export and analysis features are restricted for sealed
                tenders during active rounds.</small>
            </div>
          </ng-container>
        </div>
      </li>
      <li class="nav-item">
        <ng-template #deleteTenderConfirmation>
          <p class="mb-2"><strong>Attention! This actions can not be undone.</strong> Suppliers will receive a
            tender
            cancellation notification and the tender will be cancelled.</p>
          <div class="row">
            <div class="col pe-1">
              <button (click)="p.close()" class="btn btn-light w-100">
                Resume
              </button>
            </div>
            <div class="col ps-1">
              <button (click)="cancelTender()" class="btn btn-danger w-100">
                Confirm
              </button>
            </div>
          </div>
        </ng-template>

        <ng-template #deleteTenderConfirmation1>
          <p class="mb-2"><strong>Attention! This actions can not be undone.</strong></p>
          <div class="row">
            <div class="col pe-1">
              <button (click)="p.close()" class="btn btn-light w-100">
                Resume
              </button>
            </div>
            <div class="col ps-1">
              <button (click)="deleteTender()" class="btn btn-danger w-100">
                Confirm
              </button>
            </div>
          </div>
        </ng-template>

        <!-- D-435: a draft is deleted, never cancelled. -->
        <ng-container *ngIf="isDraft() && user.canManageAdvanced(tender) && !tender.isImported">
        <ng-template #deleteDraftConfirmation>
          <p class="mb-2">The draft and its locations, documents and cover letter will be deleted. No
            notifications will be sent.</p>
          <div class="row">
            <div class="col pe-1">
              <button (click)="draftPop.close()" class="btn btn-light w-100">
                Cancel
              </button>
            </div>
            <div class="col ps-1">
              <button (click)="deleteDraft()" class="btn btn-danger w-100" data-testid="classic-delete-draft-confirm">
                Delete Draft
              </button>
            </div>
          </div>
        </ng-template>

        <a class="nav-link pe-0"
          [ngbPopover]="deleteDraftConfirmation" popoverTitle="" placement="left" href="#"
          (click)="$event.preventDefault()" data-testid="classic-delete-draft" #draftPop="ngbPopover">
          Delete Draft
        </a>
        </ng-container>

        <a *ngIf="!tender.isDone() && !isDraft() && user.canManageAdvanced(tender) && !tender.isImported" class="nav-link pe-0"
          [ngbPopover]="deleteTenderConfirmation" popoverTitle="" placement="left" href="#"
          (click)="$event.preventDefault()" data-testid="classic-cancel-tender">
          Cancel Tender
        </a>

        <a *ngIf="!user.isViewer() && tender.isImported" class="nav-link pe-0" [ngbPopover]="deleteTenderConfirmation1"
          popoverTitle="" placement="left" href="#" (click)="$event.preventDefault()">
          Delete Tender
        </a>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid tender-header-bg shadow-sm stats border-bottom  px-4 " id="collapseTenderStats"
  [ngbCollapse]="isCollapsed">
  <div class="row text-center">
    <div class="col-12 col-sm-4 col-lg-2">
      <div class="field border-end">
        <div class="value">
          {{ tender.stats.contractsTotal }}
        </div>
        <div class="label">Locations</div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2">
      <div class="field border-end">
        <div class="value">
          {{ tender.stats.suppliersTotal }}
        </div>
        <div class="label">Invited Suppliers</div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2">
      <div class="field border-end">
        <div class="value">
          {{ tender.stats.suppliersOfferPlaced }}
        </div>
        <div class="label">Active Suppliers</div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2">
      <div class="field border-end">
        <div class="value">
          {{ tender.stats.bidsSubmittedTotal }}
        </div>
        <div class="label">Offers Received</div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2">
      <div class="field border-end">
        <div class="value">
          {{ tender.stats.offersDeclined }}
        </div>
        <div class="label">Declined Offers</div>
      </div>
    </div>
    <div class="col-12 col-sm-4 col-lg-2">
      <div class="field">
        <div class="value">
          {{ tender.stats.contractsAwarded }}
        </div>
        <div class="label">Awarded Locations</div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>